/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RegenerateScopedApiKeyRequestBody = {
  keyId: string;
};

export type RegenerateScopedApiKeyRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  requestBody?: RegenerateScopedApiKeyRequestBody | undefined;
};

/**
 * Rotated (new plaintext returned once)
 */
export type RegenerateScopedApiKeyResponseBody = {
  id: string;
  key: string;
  start: string;
};

/** @internal */
export const RegenerateScopedApiKeyRequestBody$inboundSchema: z.ZodType<
  RegenerateScopedApiKeyRequestBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  keyId: z.string(),
});
/** @internal */
export type RegenerateScopedApiKeyRequestBody$Outbound = {
  keyId: string;
};

/** @internal */
export const RegenerateScopedApiKeyRequestBody$outboundSchema: z.ZodType<
  RegenerateScopedApiKeyRequestBody$Outbound,
  z.ZodTypeDef,
  RegenerateScopedApiKeyRequestBody
> = z.object({
  keyId: z.string(),
});

export function regenerateScopedApiKeyRequestBodyToJSON(
  regenerateScopedApiKeyRequestBody: RegenerateScopedApiKeyRequestBody,
): string {
  return JSON.stringify(
    RegenerateScopedApiKeyRequestBody$outboundSchema.parse(
      regenerateScopedApiKeyRequestBody,
    ),
  );
}
export function regenerateScopedApiKeyRequestBodyFromJSON(
  jsonString: string,
): SafeParseResult<RegenerateScopedApiKeyRequestBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RegenerateScopedApiKeyRequestBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RegenerateScopedApiKeyRequestBody' from JSON`,
  );
}

/** @internal */
export const RegenerateScopedApiKeyRequest$inboundSchema: z.ZodType<
  RegenerateScopedApiKeyRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  RequestBody: z.lazy(() => RegenerateScopedApiKeyRequestBody$inboundSchema)
    .optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "RequestBody": "requestBody",
  });
});
/** @internal */
export type RegenerateScopedApiKeyRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  RequestBody?: RegenerateScopedApiKeyRequestBody$Outbound | undefined;
};

/** @internal */
export const RegenerateScopedApiKeyRequest$outboundSchema: z.ZodType<
  RegenerateScopedApiKeyRequest$Outbound,
  z.ZodTypeDef,
  RegenerateScopedApiKeyRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  requestBody: z.lazy(() => RegenerateScopedApiKeyRequestBody$outboundSchema)
    .optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    requestBody: "RequestBody",
  });
});

export function regenerateScopedApiKeyRequestToJSON(
  regenerateScopedApiKeyRequest: RegenerateScopedApiKeyRequest,
): string {
  return JSON.stringify(
    RegenerateScopedApiKeyRequest$outboundSchema.parse(
      regenerateScopedApiKeyRequest,
    ),
  );
}
export function regenerateScopedApiKeyRequestFromJSON(
  jsonString: string,
): SafeParseResult<RegenerateScopedApiKeyRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RegenerateScopedApiKeyRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RegenerateScopedApiKeyRequest' from JSON`,
  );
}

/** @internal */
export const RegenerateScopedApiKeyResponseBody$inboundSchema: z.ZodType<
  RegenerateScopedApiKeyResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  key: z.string(),
  start: z.string(),
});
/** @internal */
export type RegenerateScopedApiKeyResponseBody$Outbound = {
  id: string;
  key: string;
  start: string;
};

/** @internal */
export const RegenerateScopedApiKeyResponseBody$outboundSchema: z.ZodType<
  RegenerateScopedApiKeyResponseBody$Outbound,
  z.ZodTypeDef,
  RegenerateScopedApiKeyResponseBody
> = z.object({
  id: z.string(),
  key: z.string(),
  start: z.string(),
});

export function regenerateScopedApiKeyResponseBodyToJSON(
  regenerateScopedApiKeyResponseBody: RegenerateScopedApiKeyResponseBody,
): string {
  return JSON.stringify(
    RegenerateScopedApiKeyResponseBody$outboundSchema.parse(
      regenerateScopedApiKeyResponseBody,
    ),
  );
}
export function regenerateScopedApiKeyResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<RegenerateScopedApiKeyResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      RegenerateScopedApiKeyResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RegenerateScopedApiKeyResponseBody' from JSON`,
  );
}
